var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-title"},[_vm._v(" 甲醇燃料电池汽车运行状况AI诊断仿真平台 "),(_vm.$route.path != '/index')?_c('div',{staticClass:"right-btn",on:{"click":_vm.goHome}},[_vm._v("返回首页")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }